Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AirtableBase = void 0;
var _react = _interopRequireDefault(require("react"));
var _generalObserver = require("../general-observer");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var AirtableBase = function AirtableBase(_ref) {
  var airtableBaseId = _ref.airtableBaseId,
    _ref$layout = _ref.layout,
    layout = _ref$layout === void 0 ? '' : _ref$layout,
    _ref$viewControls = _ref.viewControls,
    viewControls = _ref$viewControls === void 0 ? 'on' : _ref$viewControls;
  return /*#__PURE__*/_react["default"].createElement(_generalObserver.GeneralObserver, null, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      position: 'relative'
    }
  }, /*#__PURE__*/_react["default"].createElement("iframe", {
    "data-testid": "airtable-base",
    title: "airtable-".concat(airtableBaseId),
    src: "https://airtable.com/embed/".concat(airtableBaseId, "?backgroundColor=green&").concat(!layout ? "" : "layout=".concat(layout, "&"), "viewControls=").concat(viewControls),
    width: "100%",
    height: "533",
    style: {
      background: 'transparent',
      border: '1px solid #ccc'
    },
    frameBorder: "0"
  })));
};
exports.AirtableBase = AirtableBase;